<template>
    <div class="icons" :class="classes">
        <span class="icon" v-for="(width, index) in icons" :key="index">
            <span
                class="icon-fill"
                v-bind:style="{ width: width + '%' }"
            ></span>
        </span>
    </div>
</template>
<style scoped lang="less">
@import "../../colors.less";

.icon {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 3px solid @mainColor;
    float: left;
    margin-right: 5px;
    position: relative;
    transition: all 0.4s;
    .icon-fill {
        display: block;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -6px;
        margin-left: -6px;
        overflow: hidden;
        &:before {
            content: "";
            display: block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: @mainColor;
            transition: all 0.4s;
            position: absolute;
        }
    }
}
.grade-color(@color) {
    .grade {
        color: @color;
    }
    .icon {
        border-color: @color;
        .icon-fill:before {
            background: @color;
        }
    }
}
.grade-horrible {
    .grade-color(@horrible);
}
.grade-bad {
    .grade-color(@bad);
}
.grade-neutral {
    .grade-color(@neutral);
}
.grade-good {
    .grade-color(@good);
}
.grade-excellent {
    .grade-color(@excellent);
}
</style>
<script>
export default {
    name: "filled-circles",
    props: {
        filled: Number,
    },
    data: () => ({
        iconsLimit: 5,
    }),
    computed: {
        classes() {
            let grades = [
                "grade-horrible",
                "grade-bad",
                "grade-neutral",
                "grade-good",
                "grade-excellent",
            ];
            for (let g in grades) {
                g = parseInt(g);
                if (this.filled <= g + 1) {
                    return [grades[g]];
                }
            }
            return [];
        },
        icons: function () {
            let icons = [];
            let filled = this.filled;
            for (var i = 0; i < this.iconsLimit; i++) {
                let width = filled - i;
                if (width >= 1) {
                    width = 100;
                } else if (width > 0) {
                    width = this.round(width * 100);
                } else {
                    width = 0;
                }
                icons.push(width);
            }
            return icons;
        },
    },
};
</script>
